/** Matches backend IsAnyAdmin: user.IsAdmin || user.RoleId == 3 */
export const isActionPlanCategoryAdmin = user =>
    Boolean(
        user?.IsSuperAdmin ||
            user?.IsAdmin === true ||
            Number(user?.RoleId) === 3,
    )

export const CREATE_NEW_CATEGORY_KEY = '__create_new_category__'

export const normalizeActionPlanCategory = item => {
    if (!item || typeof item !== 'object') {
        return { id: null, name: '', isActive: true }
    }
    return {
        id: item.CategoryId ?? item.Id ?? item.id ?? null,
        name:
            item.CategoryName ??
            item.Name ??
            item.name ??
            '',
        isActive:
            item.IsActive !== false &&
            item.isActive !== false &&
            item.IsActive !== 0,
        companyId: item.CompanyId ?? item.companyId ?? null,
    }
}

export const normalizeActionPlanCategoryList = response => {
    const list = Array.isArray(response)
        ? response
        : response?.Items || response?.Data || response?.data || []
    return list.map(normalizeActionPlanCategory).filter(c => c.id != null)
}

export const buildCategoryPayload = form => ({
    CategoryName: String(form.name || '').trim(),
    ...(form.isActive === undefined ? {} : { IsActive: Boolean(form.isActive) }),
})

export const categoryMatchesSearch = (category, search) => {
    const q = String(search || '')
        .trim()
        .toLowerCase()
    if (!q) return true
    return String(category?.name || '')
        .toLowerCase()
        .includes(q)
}

export const getApiErrorMessage = err => {
    const status = err?.status ?? err?.response?.status
    if (status === 409) {
        return (
            err?.error?.Message ||
            err?.error?.message ||
            err?.response?.data?.Message ||
            'A category with this name already exists.'
        )
    }
    if (status === 403) {
        return 'Only admins can manage ticket categories.'
    }
    if (status === 404) {
        return 'Category API is not available on this server yet. Ask backend to deploy ActionPlanCategory (works on QA; missing on Prod until release).'
    }
    const data = err?.error ?? err?.response?.data
    if (typeof data === 'string') {
        if (
            data.includes('No HTTP resource was found') ||
            data.includes('ActionPlanCategory')
        ) {
            return 'Category API is not available on this server yet. Ask backend to deploy ActionPlanCategory (works on QA; missing on Prod until release).'
        }
        return data
    }
    return (
        data?.Message ??
        data?.message ??
        err?.message ??
        'Something went wrong'
    )
}
